import { render, staticRenderFns } from "./ProductServiceTab.vue?vue&type=template&id=6537a875&"
import script from "./ProductServiceTab.vue?vue&type=script&lang=ts&"
export * from "./ProductServiceTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6537a875')) {
      api.createRecord('6537a875', component.options)
    } else {
      api.reload('6537a875', component.options)
    }
    module.hot.accept("./ProductServiceTab.vue?vue&type=template&id=6537a875&", function () {
      api.rerender('6537a875', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/internal-contract/ProductServiceTab.vue"
export default component.exports